import { ONLY_ADMIN, ADMIN_OR_COMPANY_ADMIN, ADMINS_AND_MANAGER, ADMINS_MANAGER_AND_TECH, ALL } from './UserRoles';
const maintenanceMenu = [
  {
    text: 'navigationMenu.maintenance',
    roles: ALL,
  },
  {
    text: 'navigationMenu.maintenanceSub.status',
    roles: ALL,
    to: '/status',
  },
  {
    text: 'navigationMenu.maintenanceSub.defectReports',
    roles: ALL,
    to: '/defectreports',
  },
  {
    text: 'navigationMenu.maintenanceSub.serviceRequests',
    roles: ALL,
    to: '/servicerequests',
  },
  {
    text: 'navigationMenu.maintenanceSub.plannedServices',
    roles: ADMINS_MANAGER_AND_TECH,
    to: '/plannedservices',
  },
  {
    text: 'navigationMenu.maintenanceSub.services',
    roles: ADMINS_MANAGER_AND_TECH,
    to: '/services',
  },
  {
    text: 'navigationMenu.maintenanceSub.partOrders',
    roles: ADMINS_AND_MANAGER,
    to: '/partorders',
  },
];

const companyManagementMenu = [
  {
    text: 'navigationMenu.companyManagement',
    roles: ADMINS_MANAGER_AND_TECH,
  },
  {
    text: 'navigationMenu.companyManagementSub.devices',
    roles: ADMINS_AND_MANAGER,
    href:
      process.env.VUE_APP_HTTP +
      process.env.VUE_APP_API_ADDRESS +
      '/device/index',
  },
  {
    text: 'navigationMenu.companyManagementSub.parts',
    roles: ADMINS_MANAGER_AND_TECH,
    href:
      process.env.VUE_APP_HTTP +
      process.env.VUE_APP_API_ADDRESS +
      '/part/index',
  },
  {
    text: 'navigationMenu.companyManagementSub.suppliers',
    roles: ADMINS_AND_MANAGER,
    href:
      process.env.VUE_APP_HTTP +
      process.env.VUE_APP_API_ADDRESS +
      '/supplier/index',
  },
  {
    text: 'navigationMenu.companyManagementSub.locations',
    roles: ADMINS_AND_MANAGER,
    href:
      process.env.VUE_APP_HTTP +
      process.env.VUE_APP_API_ADDRESS +
      '/location/index',
  },
  {
    text: 'navigationMenu.companyManagementSub.users',
    roles: ADMIN_OR_COMPANY_ADMIN,
    href:
      process.env.VUE_APP_HTTP +
      process.env.VUE_APP_API_ADDRESS +
      '/users/index',
  },
  {
    text: 'navigationMenu.companyManagementSub.companies',
    roles: ADMIN_OR_COMPANY_ADMIN,
    href:
      process.env.VUE_APP_HTTP +
      process.env.VUE_APP_API_ADDRESS +
      '/company/index',
  },
  {
    text: 'navigationMenu.companyManagementSub.settings',
    roles: ADMIN_OR_COMPANY_ADMIN,
    to: '/settings',
  },
];

const reportingMenu = [
  {
    text: 'navigationMenu.reporting',
    roles: ADMINS_AND_MANAGER,
  },
  {
    text: 'navigationMenu.reportingSub.costReport',
    roles: ADMINS_AND_MANAGER,
    href:
      process.env.VUE_APP_HTTP +
      process.env.VUE_APP_API_ADDRESS +
      '/report/costreport',
  },
  {
    text: 'navigationMenu.reportingSub.serviceReport',
    roles: ADMINS_AND_MANAGER,
    href:
      process.env.VUE_APP_HTTP +
      process.env.VUE_APP_API_ADDRESS +
      '/report/servicereport',
  },
  {
    text: 'navigationMenu.reportingSub.inventoryReport',
    roles: ADMINS_AND_MANAGER,
    href:
      process.env.VUE_APP_HTTP +
      process.env.VUE_APP_API_ADDRESS +
      '/report/inventoryreport',
  },
];

const systemMaintenanceMenu = [
  {
    text: 'navigationMenu.systemMaintenance',
    roles: ONLY_ADMIN,
  },
  {
    text: 'navigationMenu.systemMaintenanceSub.siteNotifications',
    roles: ONLY_ADMIN,
    to: '/sitenotifications',
  },
  {
    text: 'navigationMenu.systemMaintenanceSub.corporations',
    roles: ONLY_ADMIN,
    to: '/corporations',
  },
];

export const filterLinks = (roles) => {
  const allMenu = [
    ...maintenanceMenu,
    ...companyManagementMenu,
    ...reportingMenu,
    ...systemMaintenanceMenu,
  ];
  const filteredMaintenance = [];

  allMenu.forEach(menuItem => {
    const menuItemRoles = menuItem.roles;
    if (roles.filter(x => menuItemRoles.includes(x)).length > 0) {
      filteredMaintenance.push(menuItem);
    }
  });

  return [...filteredMaintenance];
};

